export const LOGO_URL = `${process.env.REACT_APP_BACKEND_URL}/api/uploads/logo/`;

// Resolve any relative /api/uploads path against backend URL
export const backendUrl = (relative) => {
  if (!relative) return "";
  if (relative.startsWith("http")) return relative;
  return `${process.env.REACT_APP_BACKEND_URL}${relative}`;
};

// Public logo helper for pages that render before auth — try common extensions
export const PUBLIC_LOGO_CANDIDATES = ["jpeg", "png", "jpg", "webp"].map(
  (ext) => `${process.env.REACT_APP_BACKEND_URL}/api/uploads/logo/mrs_logo.${ext}`
);

export const formatINR = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "₹0.00";
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(Number(v));
};

// Parse a local calendar date (YYYY-MM-DD) without any UTC / timezone shifting.
// Using `new Date("YYYY-MM-DD")` parses as UTC midnight and can display the
// previous/next calendar day depending on the browser timezone offset.
export const parseLocalDate = (iso) => {
  if (!iso) return null;
  const s = String(iso).slice(0, 10);
  const [y, m, d] = s.split("-").map((n) => parseInt(n, 10));
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d); // local midnight — no TZ shift
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  const d = parseLocalDate(iso);
  if (!d) return iso;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const DEPARTMENTS = ["Production", "Loading", "Office", "Security", "Maintenance", "Transport", "Other"];
